<ng-container *ngIf="certificate.typeCertificate == 3; else notOTP">
  <h2 mat-dialog-title mat-dialog-draggable-special> {{'title.info_digital_certificate_otp' | translate}}
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
</ng-container>
<ng-template #notOTP>
  <h2 mat-dialog-title mat-dialog-draggable-special> {{'title.view_digital_certificate' | translate}}
    {{certificate.issuedTo}}
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
</ng-template>
<mat-divider></mat-divider>
<mat-dialog-content #focus tabindex="-1">
  <form *ngIf="certificate" name="form" #f="ngForm" appFocusFirstElement>
    <ng-container *ngIf="certificate.typeCertificate == 3; else notOTP">
      <div class="row mt-3">
        <div class="col-12">
          <mat-label>
            <small>{{'digital_certificate_management.lbl_phone' | translate}}</small>
            <p class="dotted">{{ certificate.phoneNumber }}</p>
          </mat-label>
        </div>
      </div>
    </ng-container>
    <ng-template #notOTP>
      <div class="row mt-3">
        <!-- Tên doanh nghiệp -->
        <div class="col-6">
          <mat-form-field class="mat-form-field-disabled">
            <input matInput [ngModel]="certificate.enterpriseName" name="certificate.enterpriseName"
                   [placeholder]="'digital_certificate_management.lbl_enterprise' | translate" [readonly]="true">
          </mat-form-field>
        </div>
        <!-- Loại chứng thư -->
        <div class="col-6">
          <mat-form-field class="mat-form-field-disabled">
            <input matInput [ngModel]="certificate.typeCertificateInText" name="certificate.typeCertificateInText"
                   [placeholder]="'digital_certificate_management.cbx_certificate_type.lbl_certificate_type' | translate"
                   [readonly]="true">
          </mat-form-field>
        </div>
        <!-- Tên chủ thể -->
        <div class="col-6">
          <mat-form-field class="mat-form-field-disabled">
            <input matInput [ngModel]="certificate.issuedTo" name="certificate.issuedTo"
                   [placeholder]="'enterprise-certificate_management.table_headers.issued_to' | translate"
                   [readonly]="true">
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field class="mat-form-field-disabled">
            <input matInput [ngModel]="certificate.issuedBy" name="certificate.issueBy"
                   [placeholder]="'digital_certificate_management.certification_organization' | translate"
                   readonly="true">
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field class="mat-form-field-disabled">
            <input matInput [ngModel]="certificate.serialNumber" name="certificate.serialNumber"
                   [placeholder]="'form.serial_number' | translate" [readonly]="true">
          </mat-form-field>
        </div>

        <div class="col-6">
          <mat-form-field class="mat-form-field-disabled">
            <input matInput [ngModel]="certificate.taxCode" name="certificate.taxCode"
                   [placeholder]="'digital_certificate_management.tax_code' | translate" [readonly]="true">
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field class="mat-form-field-disabled">
            <input matInput [ngModel]="certificate.activeDate | dateformat" name="certificate.activeDate"
                   [placeholder]="'enterprise-certificate_management.table_headers.effective_date' | translate"
                   [readonly]="true">
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field class="mat-form-field-disabled">
            <input matInput [ngModel]="certificate.expireDate | dateformat" name="certificate.expireDate"
                   [placeholder]="'enterprise-certificate_management.table_headers.expiry_date' | translate"
                   [readonly]="true">
          </mat-form-field>
        </div>
        <!-- Tên file -->
        <div class="col-6" *ngIf="certificate.filePath">
          <mat-form-field class="mat-form-field-disabled">
            <input matInput [ngModel]="certificate.filePath" name="certificate.filePath"
                   [placeholder]="'enterprise-certificate_management.table_headers.file_path' | translate"
                   [readonly]="true">
          </mat-form-field>
        </div>

        <div class="col-6" *ngIf="certificate.cloudCaUsername">
          <mat-form-field class="mat-form-field-disabled">
            <input matInput [ngModel]="certificate.cloudCaUsername" name="certificate.cloudCaUsername"
                   [placeholder]="'enterprise-certificate_management.table_headers.cloud_ca_username' | translate"
                   [readonly]="true">
          </mat-form-field>
        </div>
        
        <div class="col-6 d-flex gap-2" *ngIf="certificate.typeCertificate == 10 && expireDate">
          <mat-form-field class="mat-form-field-disabled">
            <input matInput [ngModel]="expireDate" name="expireDate"
                   [placeholder]="'digital_certificate_management.expire_date_title' | translate"
                   [readonly]="true">
          </mat-form-field>
          <button mat-icon-button type="button" style="margin-top: 15px;"
            (click)="deleteSession()">
            <i class="fa fa-trash" style="font-size: 20px;" aria-hidden="true" matTooltip="{{ 'digital_certificate_management.btn_delete_session' | translate }}"></i>
          </button>
        </div>

        <div class="col-6 d-flex gap-2" *ngIf="certificate.typeCertificate == 11">
          <mat-form-field>
            <button matSuffix mat-icon-button color="primary" type="button" (click)="showPinCode = !showPinCode">
              <mat-icon>{{!showPinCode ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <input [ngClass]="{ 'is-invalid': f.submitted && pin.invalid }" matInput [type]="showPinCode ? 'text' : 'password'" #focusInput [placeholder]="'digital_certificate_management.pin_code' | translate"
              name="pin" id="pin-fake" [(ngModel)]="certificate.pin" (ngModelChange)="isFormChanging = true"
              #pin="ngModel" required maxlength="10" autocomplete="new-password" />
            <mat-error *ngIf="f.submitted || pin?.errors?.required">
              <span class="text-error">{{'validation.pin_code_required' | translate}}</span>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-6 d-flex gap-2" *ngIf="certificate.typeCertificate == 10">
          <mat-form-field>
            <input matInput type="text" [placeholder]="'headertable.auto_sync_mysign' | translate"
              name="certificate.isSync" [(ngModel)]="certificate.isSync" [readonly]="true"/>
          </mat-form-field>
        </div>

      </div>
    </ng-template>

    <div class="row mt-3">
      <!-- block chon anh chu ky mac dinh 3 tab (PYC-84222 task 3); label "Chọn ảnh chữ ký" nằm trong block -->
      <div class="col-6 pr-075" *ngIf="certificate.typeCertificate !== 3">
        <app-default-sign-image-config
          [defaultSignImageType]="pendingDefaultSignImageType"
          [savedSignConfigJson]="savedSignConfigJson"
          [savedImageBase64]="avatarUrlB64"
          [savedDrawImageBase64]="savedDrawImageBase64"
          [issuedTo]="certificate.issuedTo"
          [typeCertificate]="certificate.typeCertificate"
          (typeChange)="onDefaultSignImageTypeChange($event)"
          (signConfigChange)="onPendingSignConfigChange($event)"
          (signatureImageChange)="onPendingSignatureImageChange($event)"
          (uploadImageChange)="onPendingUploadImageChange($event)"
          (drawImageChange)="onPendingDrawImageChange($event)">
        </app-default-sign-image-config>
      </div>
      <!-- upload anh ky cu (typeCertificate !== 3) đã bỏ vì trùng tab "Ảnh ký" trong block 3-tab (PYC-84222 task 3) -->
      <!-- luong cu cho OTP: giu nguyen toan bo upload anh -->
      <div class="col-12" *ngIf="certificate.typeCertificate === 3">
        <div nz-upload-btn class="ant-upload mb-2">
          <div class="upload-note d-flex pb-2">
            <span
              style="margin-bottom: 0.5em; font-family: inherit; display: inline-block; color: rgba(0, 0, 0, 0.65);">{{'title.upload_image_sign' | translate}}</span>
            <small class="ml-1 mr-2"><i style="font-size: 0.8rem;">({{'title.upload_image_sign_guiding6' | translate}}
              )</i></small>
            <mat-icon matSuffix
                      matTooltip="{{'title.upload_image_sign_guiding5' | translate}}"
                      class="custom-position-for-icon">help_outline
            </mat-icon>
          </div>
          <div class="clearfix nz-upload-clearfix">
            <div class="col-12 pr-075 pl-0">
              <div class="wrap-upload">
                <div style="text-align: center">
                  <nz-upload style="max-width: 100% !important;padding:1rem 1rem 0 1rem" [nzAccept]="'image/jpeg,image/jpg,image/png'" [nzPreview]="handlePreview"
                             class="avatar-uploader"
                             [nzCustomRequest]="dummyRequest" nzName="avatar" nzListType="picture-card"
                             [nzShowUploadList]="false"
                             [nzBeforeUpload]="beforeUpload" (nzChange)="handleChange($event)"
                             [nzDisabled]="commonService.getIsLockedEnterprise()">
                    <ng-container *ngIf="!avatarUrl">
                      <i class="upload-icon" nz-icon [nzType]="loading ? 'loading' : 'plus'"></i>
                      <div class="ant-upload-text">Upload</div>
                    </ng-container>
                    <img *ngIf="avatarUrl" [src]="sanitize(avatarUrl)" style="width: 100%"/>
                  </nz-upload>
                </div>
                <div *ngIf="avatarUrl!=''&&avatarUrl!=null" style="text-align:right; padding-right: 1rem;">
                  <i (click)="confirmDelete()" class="fa fa-trash mb-2"
                  aria-hidden="true" matTooltip="{{'tooltips.delete' | translate}}"></i>
                </div>
              </div>
              <nz-modal [nzVisible]="previewVisible" [nzContent]="modalContent" [nzFooter]="null"
                        (nzOnCancel)="previewVisible = false">
                <ng-template #modalContent>
                  <img [src]="sanitize(avatarUrl)" [ngStyle]="{ width: '100%' }"/>
                </ng-template>
              </nz-modal>
            </div>
          </div>
          <mat-error *ngIf="wrongFileFormat">
            {{'messages.only_accept_png_jpg' | translate}}
          </mat-error>
          <mat-error *ngIf="fileTooLarge">
            {{'messages.image_must_than_2m' | translate}}
          </mat-error>
        </div>
      </div>
      <!--    list nguoi quan ly-->
      <div class="col-6 pr-075" *ngIf="certificate.typeCertificate !== 3">
        <mat-panel-title class="mat-panel-title border-0 m-0 p-0">
          <span class="ant-upload pb-2"
                style="margin-bottom: 0.5em; font-family: inherit; display: inline-block; color: rgba(0, 0, 0, 0.65);">{{'enterprise-certificate_management.table_headers.user_management' | translate}}</span>
        </mat-panel-title>
        <nz-table nzBordered [nzNoResult]="null" [nzData]="certificate.lstIdNameDTO" nzShowPagination=false
                  class="ant-table-no-placeholder-border-bottom border-top-0">
          <tbody>
          <tr *ngFor="let username of certificate.lstIdNameDTO" class="editable-row">
            <td>{{username.name}}</td>
          </tr>
          </tbody>
        </nz-table>
      </div>
    </div>
    </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="center" class="mt-2">
  <button mat-stroked-button color="primary" (click)="onCancel()" class="mr-3" type="button">
    <mat-icon class="mr-0">cancel</mat-icon>
    {{'view_pdf.buttons.close' | translate}}
  </button>
  <button mat-raised-button color="primary" [disabled]="isSignImageInvalid || !isFormChanging" (click)="onUpdateCertificateImage()"
          class="mr-3" type="button" [mat-dialog-close]="true">
    <mat-icon class="mr-0">save</mat-icon>
    {{'button.save' | translate}}
  </button>
</mat-dialog-actions>
